import React, { useContext } from 'react';
import AppointmentForm from './AppointmentForm';
import AdmissionForm from '../Admission/AdmissionForm';
import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import MessagesContext from '../../contexts/messagesContext';
const styles = makeStyles({
    container: {
        maxWidth: '545px'
    },
    appointmentList: {
        marginTop: '32px'
    }
});
export default function NewAppointment(props) {
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    const handleSetSynchronousAdmit = (e) => {
        props.setActiveStep(e);
        props.handleNavigation(e);
    };
    return (
        <div className={classes.container}>
            {props.activeStep ? (
                <AdmissionForm
                    {...props}
                    title={messages.synchronousAdmission}
                    destinationState={'admitted'}
                    synchronousAdmission={props.activeStep}
                    handleGoBack={() => handleSetSynchronousAdmit(false)}
                    closeModal={props.closeModal}
                />
            ) : (
                <AppointmentForm
                    {...props}
                    triggerSynchronousAdmission={() => {
                        handleSetSynchronousAdmit(true);
                    }}
                    closeModal={props.closeModal}
                />
            )}
        </div>
    );
}
NewAppointment.propTypes = {
    handleNavigation: PropTypes.func,
    activeStep: PropTypes.number,
    closeModal: PropTypes.func,
    setActiveStep: PropTypes.func
};
